import React, { createContext, useContext, useState } from "react";
const WorkspaceContext = createContext(null);
export const WorkspaceProvider = ({ children }) => {
  const [workspaceController, setWorkspaceController] = useState(null);
  return (
    <WorkspaceContext.Provider
      value={{ workspaceController, setWorkspaceController }}
    >
      {children}
    </WorkspaceContext.Provider>
  );
};
export const useWorkspace = () => useContext(WorkspaceContext);
